import { MetricUId } from "../../Metrics/constants"
import getChartConfigTemplate from "../Templates/PieChart/utils"
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.PENDING_MEETING_REQUESTS]: "#F76B15",
  [MetricUId.ACCEPTED_MEETING_REQUESTS]: "#0969DA",
  [MetricUId.WITHDRAWN_MEETING_REQUESTS]: "#D0D6DB",
  [MetricUId.REJECTED_MEETING_REQUESTS]: "#E54D2E",
  [MetricUId.CLOSED_MEETING_REQUESTS]: "#8E4EC6"
}

export const chartOnlyMetrics = [MetricUId.PENDING_MEETING_REQUESTS, MetricUId.ACCEPTED_MEETING_REQUESTS, MetricUId.WITHDRAWN_MEETING_REQUESTS, MetricUId.REJECTED_MEETING_REQUESTS, MetricUId.CLOSED_MEETING_REQUESTS, MetricUId.TOTAL_MEETING_REQUESTS]

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.PENDING_MEETING_REQUESTS, MetricUId.ACCEPTED_MEETING_REQUESTS, MetricUId.WITHDRAWN_MEETING_REQUESTS, MetricUId.REJECTED_MEETING_REQUESTS, MetricUId.CLOSED_MEETING_REQUESTS],
    subTitleMetricUid: MetricUId.TOTAL_MEETING_REQUESTS,
    exportFileName: props.name,
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;